import { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { getNodeDisplayLabel, useFlowDisplayLanguage } from '../../displayLanguage';
import { COIN_FLIP_SOURCE_HANDLES } from '../coinFlipHandles';
import { CardShell } from '../CardShell';

export const CoinFlipNodeView = memo(function CoinFlipNodeView() {
  const displayLanguage = useFlowDisplayLanguage();

  return (
    <CardShell
      kind="coinFlip"
      accent="slate"
      title={getNodeDisplayLabel('coinFlip', displayLanguage)}
      summary=""
    >
      <div className="flow-node__port-label flow-node__port-label--in text-slate-700" style={{ top: '50%', transform: 'translateY(-50%)' }}>
        {displayLanguage === 'en' ? 'input' : '入力'}
      </div>
      <div className="flow-node__port-label flow-node__port-label--out text-slate-700" style={{ top: '30%', transform: 'translateY(-50%)' }}>
        {displayLanguage === 'en' ? 'heads' : '表'}
      </div>
      <div className="flow-node__port-label flow-node__port-label--out text-slate-700" style={{ top: '70%', transform: 'translateY(-50%)' }}>
        {displayLanguage === 'en' ? 'tails' : '裏'}
      </div>

      <Handle type="target" position={Position.Left} style={{ top: '50%' }} className="!bg-slate-500" />
      <Handle
        id={COIN_FLIP_SOURCE_HANDLES.heads}
        type="source"
        position={Position.Right}
        style={{ top: '30%' }}
        className="!bg-slate-500"
      />
      <Handle
        id={COIN_FLIP_SOURCE_HANDLES.tails}
        type="source"
        position={Position.Right}
        style={{ top: '70%' }}
        className="!bg-slate-500"
      />
    </CardShell>
  );
});
